import { render, staticRenderFns } from "./ShowConsentDocument.vue?vue&type=template&id=43642a71"
import script from "./ShowConsentDocument.vue?vue&type=script&lang=js"
export * from "./ShowConsentDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports